export default {
  SET_WHATSAPP_AUTH(state, payload) {
    state.whatsappAuth = payload;
  },
};
